// components/rental-managers/TenantGuidedTours.jsx


import React from 'react';
import { Box, Typography, Grid } from '@mui/material';

const TenantGuidedTours = () => {
  return (
    <Box sx={{ py: 8 }}>
      <Typography variant="h2" sx={{ mb: 4, fontSize: '2.5rem', fontWeight: 'bold' }}>
        Tenant Guided Tours Cost Illustration
      </Typography>

      <Grid container spacing={4}>
        {/* General Access Fee */}
        <Grid item xs={12} md={6}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            General Access Fee for Property Managers
          </Typography>
          <Typography>$24.95 General Access Monthly Subscription Fee</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Covers all properties and general access for maintenance teams for just $24.95 per month including automated showings access. Paid Net 30
          </Typography>
        </Grid>

        {/* Per Property Keyless Access */}
        <Grid item xs={12} md={6}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Per Property Keyless Access Management
          </Typography>
          <Typography>$12.75 Per Property/Per Month</Typography>
          <Typography>+$24.95 Per Property/Per Month Paid By Tenant "optional"</Typography>
          <Typography variant="body1">
            Collect a $24.95 Technology Fee on your next new lease or with an amended lease where tenants agree to pay for the use of doorbell camera, smart lock automation controls, Echo Dot media capabilities with chime, and more.
          </Typography>
        </Grid>

        {/* Tenant Benefits */}
        <Grid item xs={12}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Tenant Benefits
          </Typography>
          <ul>
            <li>Tenants grant access to guests or house sitters with one-time use passcodes (no more hiding keys)</li>
            <li>Tenants see who is coming and going at all times and receive maintenance alerts</li>
            <li>Maintenance access with one-time pass codes</li>
            <li>Tenants receive motion-activated alerts from doorbell camera when someone is at their rented home</li>
            <li>Tenants move in with full secure access and WIFI at day one of occupancy</li>
            <li>Echo Dot serves as media device and speaker that doubles as a portable door chime device for your doorbell camera</li>
          </ul>
        </Grid>

        {/* Equipment Rental */}
        <Grid item xs={12} md={6}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Per Property Full Equipment Rental
          </Typography>
          <Typography>$25 Monthly - Paid by Rental Owners or Management Companies, or Both</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Includes Schlage Encode Smart lock, one digital lock for side doors or back doors, modem for WIFI, doorbell camera, Echo Dot (or similar) to work as doorbell chime and multi-purpose media
          </Typography>
          <Typography>Replaces Rekeying Costs | Secures Access | Provides Vacant Property Monitoring</Typography>
          <Typography>+ $5 Per Month Paid By Tenants for modem rental "optional"</Typography>
          <Typography>$20 Net Equipment Monthly Costs</Typography>
        </Grid>

        {/* Additional Benefits */}
        <Grid item xs={12}>
          <Typography variant="body1">
            Management companies save time on driving to properties just for the purpose of delivering keys or possession at tenant turnovers. Changing access in between tenants is a few button clicks away. No more lockbox costs for any reason or hard copy keys. Provide access to properties from anywhere. Landlords may amend management agreements or add to new management agreements that the net equipment monthly cost of $20 to start using smart locks is enacted as rekeys become imminent, or get started right away if all parties agree to the convenience costs sooner by amending their agreements for the costs. Most hardware can be installed easily while your maintenance is out on their next scheduled unit turn on the same trip.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TenantGuidedTours;